import '../scss/main.scss';
import ProjectSituationMap from './project-situation-map';

window.addEventListener('DOMContentLoaded', () => {
	let projectSituationMapWrappers = document.querySelectorAll('.project-situation-map-wrapper');

	if (projectSituationMapWrappers.length < 1) {
		return;
	}

	projectSituationMapWrappers = [].slice.call(projectSituationMapWrappers);

	projectSituationMapWrappers.forEach(container => {
		let projectSituationMapLegenda = container.querySelector('.project-situation-map-legenda');
		let projectSituationMapContainer = container.querySelector('.project-situation-map-container');
		let projectSituationInfowindowContainer = container.querySelector('.project-situation-infowindow-container');

		window.projectSituationMap = new ProjectSituationMap(
			projectSituationMapLegenda,
			projectSituationMapContainer,
			projectSituationInfowindowContainer,
			{
				projects: ajax_url_get_projects,
				projectViews: ajax_url_module_project_situation_map_get_projects
			}
		);
	});
});

window.addEventListener('DOMContentLoaded', () => {
	let mapElement = document.querySelectorAll('.project-situation-map-container');
	let observer;
	let options = {
		root: null,
		threshold: 0.6
	};
	observer = new IntersectionObserver((entries, observer) => {
		entries.forEach((entry) => {
			var windowWidth = Math.floor(entry.target.children[0].offsetWidth/4);
			if (entry.isIntersecting) {
				entry.target.scrollBy({
					top: 0,
					left: windowWidth,
					behavior: 'smooth'
				});
				observer.unobserve(entry.target);
			}
		});
	}, options);

	mapElement.forEach((element) => {
		observer.observe(element);
	});


});